import type IAssociationType from '@/components/organisation/interface/IAssociationType'
import { useOrganisationStore } from '@/stores/organisation.store'
// import axios from 'axios'

/**
 * @param id  organisation account id
 * @returns The IPermission[]
 */
// const setActiveAccount = async (id: number): Promise<IAssociationType[]> => {
//   return await axios
//     .post('/api/account/setActiveAccount', { id: id })
//     .then((response) => {
//       return response.data
//     })
//     .catch((error) => {
//       throw error
//     })
// }

/**
 * @param id  organisation account id
 * @param isDelayed  organisation account id
 * @returns The IPermission[]
 */
const setActiveAccount = async (
  id: number,
  isDelayed: boolean = true
): Promise<IAssociationType[]> => {
  const activeAccount =
    useOrganisationStore().associations?.find((account) => account.accountId === id)
      ?.associationTypes ?? []

  return new Promise((resolve) => {
    setTimeout(
      async () => {
        resolve(activeAccount)
      },
      isDelayed ? 2000 : 0
    )
  })
}

export { setActiveAccount }
